import { render, staticRenderFns } from "./TradingView.vue?vue&type=template&id=12e185b6&scoped=true&"
import script from "./TradingView.vue?vue&type=script&lang=js&"
export * from "./TradingView.vue?vue&type=script&lang=js&"
import style0 from "./TradingView.vue?vue&type=style&index=0&id=12e185b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e185b6",
  null
  
)

export default component.exports